import { render, staticRenderFns } from "./BFormPlan.vue?vue&type=template&id=91143ad8&scoped=true&"
import script from "./BFormPlan.vue?vue&type=script&lang=js&"
export * from "./BFormPlan.vue?vue&type=script&lang=js&"
import style0 from "./BFormPlan.vue?vue&type=style&index=0&id=91143ad8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91143ad8",
  null
  
)

export default component.exports